import { CHECK_IF_DRAFT_EXISTS } from '../../helpers/graphql/drafts';
import { useQuery } from '@apollo/client';
import Router from 'next/router';
import emoji from 'components/emoji';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { useEffect } from 'react';

export default function AiBloggerProgressCheck({ draftId }) {
  const { data, startPolling } = useQuery(CHECK_IF_DRAFT_EXISTS, {
    variables: { id: draftId },
    // eslint-disable-next-line no-use-before-define
    ssr: false,
  });

  useEffect(() => {
    startPolling(5000);
  }, [startPolling]);

  useEffect(() => {
    if (data && data.draft)
      Router.push({
        pathname: '/dashboard/publish',
        query: { draftId: draftId || 'pending' },
      });
  }, [data]);

  const aiWarnings = [
    {
      emoji: '📝',
      text: `It's cool to admit we need a little help from our human friends. Editing is your secret weapon to make this post awesome.`,
    },
    {
      emoji: '👀',
      text:
        'Before you hit that publish button, give this post a quick review.',
    },
    {
      emoji: '✋',
      text: `AI is pretty smart, but it's not perfect. Double-check those facts!`,
    },
    {
      emoji: '📸',
      text:
        'Spice it up, amigo! Throw in some of your own personal flavor with some sweet pics and links.',
    },
  ];

  return (
    <List>
      {aiWarnings.map(warning => (
        <ListItem disablePadding key={warning.text}>
          <ListItemIcon>
            <span className="tw-text-3xl">{emoji(warning.emoji)}</span>
          </ListItemIcon>
          <ListItemText primary={warning.text} />
        </ListItem>
      ))}
    </List>
  );
}
